import { render } from "./ReqAgentResignationView.vue?vue&type=template&id=57e2908c"
import script from "./ReqAgentResignationView.vue?vue&type=script&lang=js"
export * from "./ReqAgentResignationView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__